<!--File: cgp-app-bar.template.js-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/27/2017-->
<!--Desc: CGP App Bar that has the company logo, navigation toggle, and user menu toggle.-->
<!--Other Contributors:-->

<div class="cgp-appbar-content" [hidden]="!show">
    <mat-toolbar color="primary" class="cgp-appbar">
        <button mat-button class="menu" *ngIf="showNavToggle" (click)="onNavToggleClick()">
            <mat-icon>
                <i class="fa fa-bars"></i>
            </mat-icon>
        </button>
        <img class="gm-logo xs-hide" src="./assets/img/GM-Flat.svg" alt="General Motors" width="100%" height="100%"/>
        <span class="title">{{ appName }}</span>
        <cgp-app-bar-user-menu *ngIf="showUserMenu"></cgp-app-bar-user-menu>
    </mat-toolbar>
</div>